import React from 'react';

interface ImposterWarningPillProps {
  show: boolean;
  className?: string;
}

/**
 * Skull icon SVG component - scary visual indicator for imposters
 */
const SkullIcon: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    className={className}
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Skull head shape */}
    <circle cx="12" cy="8" r="6" />
    {/* Skull jaw */}
    <path d="M6 12 Q6 16 8 18 Q12 20 16 18 Q18 16 18 12" />
    {/* Left eye */}
    <circle cx="9" cy="7" r="1.5" />
    {/* Right eye */}
    <circle cx="15" cy="7" r="1.5" />
    {/* Nose */}
    <path d="M12 10 Q11 11 12 12 Q13 11 12 10" />
    {/* Teeth */}
    <rect x="10" y="14" width="1" height="2" rx="0.5" />
    <rect x="12" y="14" width="1" height="2" rx="0.5" />
    <rect x="14" y="14" width="1" height="2" rx="0.5" />
  </svg>
);

/**
 * Warning pill component for displaying imposter alerts
 * Shows a red pill with skull icon and "Possible Imposter" text
 */
export const ImposterWarningPill: React.FC<ImposterWarningPillProps> = ({ 
  show, 
  className = '' 
}) => {
  if (!show) return null;

  return (
    <div
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-600 text-white border border-red-700 shadow-sm ${className}`}
      role="alert"
      aria-label="Possible imposter detected - Match Level 0"
    >
      <SkullIcon className="mr-1.5 w-3 h-3" />
      <span className="font-semibold">Possible Imposter</span>
      <span className="ml-1.5 text-red-200">Match Level 0</span>
    </div>
  );
};

export default ImposterWarningPill;
